// src/components/LinkedIn/LinkedInPost.js
// Cookie-free LinkedIn post display component
// This component displays LinkedIn posts without requiring cookies or tracking

import React from 'react';

/**
 * LinkedIn Post Component - Cookie-Free Implementation
 * 
 * This component displays LinkedIn posts without using cookies.
 * Options:
 * 1. Simple link display (current implementation - fully cookie-free)
 * 2. Static screenshot/image (if you have permission to use)
 * 3. LinkedIn oEmbed API (requires API key but can be configured privacy-friendly)
 * 
 * For full embed functionality, LinkedIn requires their JavaScript SDK,
 * but we can configure it to minimize tracking.
 */
const LinkedInPost = ({
    url,
    title = "View on LinkedIn",
    excerpt = null,
    showPreview = false,
    previewImage = null
}) => {
    return (
        <div className="border border-gray-300 rounded-lg p-6 bg-white hover:shadow-lg transition-shadow">
            {showPreview && previewImage && (
                <div className="mb-4">
                    <img 
                        src={previewImage} 
                        alt={title}
                        className="w-full h-auto rounded"
                    />
                </div>
            )}
            
            <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                    <svg 
                        className="w-8 h-8 text-blue-600" 
                        fill="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                </div>
                <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {title}
                    </h3>
                    {excerpt && (
                        <p className="text-sm text-gray-600 mb-4 text-justify">
                            {excerpt}
                        </p>
                    )}
                    <a 
                        href={url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold"
                    >
                        Open on LinkedIn
                        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LinkedInPost;

